<app-menu-common url="sales"></app-menu-common>
@if (formGroup) {
  <div>
    <div class="pageheader flexcolumn" [formGroup]="formGroup">
      <section class="flexrow">
        @if (!id) {
          <div class="grey pagetitle">Nouvelle offre promotionnelle</div>
        }
        @if (id) {
          <div class="grey pagetitle">Offre</div>
        }
        <span class="spacer"></span>
        @if (id) {
          <div class="grey pagetitle">#&nbsp;{{id}}</div>
        }
      </section>
      <div class="flexgrid"></div>
    </div>
    <app-action-bar form="mainform" (submitEmitter)="onActionBarSubmit($event)" [hassave]="true"> </app-action-bar>
    <div class="pagecontent">
      <form  (ngSubmit)="onSubmit()" id="mainform">
        <div class="maincontent">
          <mat-tab-group>
            <mat-tab label="Déclencheur">
              <section class="cb-section">
                <mat-radio-group [(ngModel)]="trigkind" name="trigkind" (change)="onChangeTrigKind()">
                  <mat-radio-button class="cb-margin" value="AMT">Remise sur montant</mat-radio-button>
                  <mat-radio-button class="cb-margin" value="QTY">Remise sur quantité</mat-radio-button>
                </mat-radio-group>
              </section>
              @if (trigkind=='AMT') {
                <section class="cb-section">
                  <mat-radio-group [(ngModel)]="trigset" name="trigset">
                    <mat-radio-button class="cb-margin" value="GLOBAL">Montant global de la commande</mat-radio-button>
                    <mat-radio-button class="cb-margin" value="ITEM">Montant d'un ensemble de produits</mat-radio-button>
                  </mat-radio-group>
                </section>
              }
              <mat-divider style="margin-bottom: 10px;"></mat-divider>
              @if (trigset==='GLOBAL') {
                <section class="flexrow">
                  <div class="paddingtop glow">Montant déclencheur&nbsp;</div>
                  <mat-form-field class="">
                    <mat-label>Montant déclencheur</mat-label>
                    <input matInput placeholder="Ex. 100" value="" [(ngModel)]="trigqty" name="trigqty">
                  </mat-form-field>
                </section>
              }
              @if (trigset==='ITEM' ) {
                <app-itemset></app-itemset>
              }
            </mat-tab>
            <mat-tab label="Conséquences">
              <section class="cb-section">
                <mat-radio-group [(ngModel)]="conskind" name="conskind">
                  <mat-radio-button class="cb-margin" value="FORCED_PRICE">Prix fixe</mat-radio-button>
                  <mat-radio-button class="cb-margin" value="AMT_DISCOUNT">Remise en montant</mat-radio-button>
                  <mat-radio-button class="cb-margin" value="PCT_DISCOUNT">Remise en %</mat-radio-button>
                </mat-radio-group>
              </section>
              @if (trigkind=='AMT') {
                <section class="cb-section">
                  <mat-radio-group [(ngModel)]="trigset" name="trigset">
                    <mat-radio-button class="cb-margin" value="">Articles déclencheurs</mat-radio-button>
                    <mat-radio-button class="cb-margin" value="">Ensemble défini</mat-radio-button>
                    <mat-radio-button class="cb-margin" value="">Montant du ticket</mat-radio-button>
                  </mat-radio-group>
                </section>
              }
              <app-outcome></app-outcome>
            </mat-tab>
          </mat-tab-group>
        </div>
      </form>
    </div>
  </div>
}

@if (id===-1) {
  <div style="padding: 20px; font-size: x-large;">ERREUR : Offre inexistante</div>
}